import { useCallback } from 'react';

import { useElementScrollLock } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$hooks';
import { useFeedbackStore } from '@store';

import { Drawers } from '../../drawers';
import { useGetValueByCreditType } from '../useGetValueByCreditType';
import { useGtm } from '../useGtm';

export interface DrawerHook {
	hide: () => void;
	show: () => void;
}

export const useDrawer = (drawerName: Drawers) => {
	const hideDrawer = useFeedbackStore((state) => state.hideDrawer);
	const showDrawer = useFeedbackStore((state) => state.showDrawer);
	const { disable } = useElementScrollLock('body');
	const { sendEvent } = useGtm();
	// cSpell: disable
	const itemType = useGetValueByCreditType(
		{
			CL: 'credito-pessoal',
			AL: 'credito-auto',
			RENEN: 'credito-edificios-sustentaveis',
			ALEV: 'credito-eletricauto',
			HOME: 'credito-lar',
			AN: 'credito-auto-novos',
			CONSTR: 'credito-obras',
			EDUCA: 'credito-educacao',
			HEALTH: 'credito-saude',
		},
		'credito-pessoal'
	);
	const screenName = `${itemType}/simulador-publico/envio-email`;

	const show = useCallback(() => {
		if (drawerName === 'sendEmail') {
			sendEvent({
				firebaseEventName: 'setScreenName',
				screen_name: screenName,
			});
			sendEvent({
				screen_name: screenName,
				eName: 'ver-drawer-envio-email',
			});
		}
		showDrawer(drawerName);
	}, [drawerName, screenName, sendEvent, showDrawer]);

	const hide = useCallback(() => {
		// if (drawerName === 'sendEmail') {
		// 	sendEvent({
		// 		screen_name: screenName,
		// 		eName: 'fechar',
		// 	});
		// }
		disable();
		hideDrawer(drawerName);
	}, [disable, drawerName, hideDrawer]);
	// cSpell: enable

	return {
		hide,
		show,
	};
};

export const useIsVisibleDrawer = (drawerName: Drawers) => {
	const visibleDrawers = useFeedbackStore((state) => state.visibleDrawers);

	return (visibleDrawers?.[drawerName] || 0) > 0;
};
